import { render, staticRenderFns } from "./priorityDetailsLists.vue?vue&type=template&id=22f71a9f&scoped=true&"
import script from "./priorityDetailsLists.vue?vue&type=script&lang=js&"
export * from "./priorityDetailsLists.vue?vue&type=script&lang=js&"
import style0 from "./priorityDetailsLists.vue?vue&type=style&index=0&id=22f71a9f&scoped=true&lang=css&"
import style1 from "./priorityDetailsLists.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f71a9f",
  null
  
)

export default component.exports